import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faXTwitter,
  faTiktok,
} from "@fortawesome/free-brands-svg-icons";
import "./SocialMediaSection.css";

const SocialMediaSection = ({ facebook, instagram, twitter, tiktok }) => {
  return (
    <div className="footer-social-icons">
      {facebook && (
        <a href={facebook} target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faFacebookF} className="social-icon" />
          <span className="sr-only">Facebook</span>
        </a>
      )}
      {instagram && (
        <a href={instagram} target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} className="social-icon" />
          <span className="sr-only">Instagram</span>
        </a>
      )}
      {twitter && (
        <a href={twitter} target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faXTwitter} className="social-icon" />
          <span className="sr-only">Twitter</span>
        </a>
      )}
      {tiktok && (
        <a href={tiktok} target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faTiktok} className="social-icon" />
          <span className="sr-only">TikTok</span>
        </a>
      )}
    </div>
  );
};

export default SocialMediaSection;
